import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import cameraConnectedIcon from 'src/assets/icons/camera-connected.svg';

import ImagesSavedCard from 'src/components/ConnectionIssueModals/ImagesSavedCard';
import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

interface CameraConnectionRetriedModalProps {
  show: boolean;
  onClose: () => void;
  showRetakeInstruction: boolean;
}

export default function CameraConnectionRetriedModal({
  show,
  onClose,
  showRetakeInstruction,
}: CameraConnectionRetriedModalProps) {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'cameraConnectionIssue.cameraConnectedModal',
  });

  return (
    <SmallModalTemplate
      show={show}
      icon={<img src={cameraConnectedIcon} alt={t('cameraImgAlt')} />}
      iconWrapperClassName="bg-success-100"
      title={t('title')}
      description={t('description')}
      backdropClassName="connection-issue-backdrop"
      style={{ zIndex: 2000 }}
      card={
        showRetakeInstruction && (
          <ImagesSavedCard text={t('retakeInstruction')} />
        )
      }
      rightButton={
        <Button
          variant="outline-gray-500"
          className="clear-exam-button button-slim"
          onClick={onClose}
        >
          {t('close')}
        </Button>
      }
    />
  );
}
